'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactHookForm = require('react-hook-form');
var getSchemaPathRequirementMap = require('../_chunks/getSchemaPathRequirementMap-DIM0tidl.js');

const FormManagerContext = react.createContext({});
// There is a pending feature request for this functionality
// https://github.com/react-hook-form/react-hook-form/projects/1#card-86984636
const FormManagerProvider = ({ schema, ...props }) => {
    const value = react.useMemo(() => ({
        schemaPathRequirementMap: schema
            ? getSchemaPathRequirementMap.getSchemaPathRequirementMap(schema)
            : undefined,
    }), [schema]);
    return (jsxRuntime.jsx(FormManagerContext.Provider, { value: value, children: jsxRuntime.jsx(reactHookForm.FormProvider, { ...props }) }));
};
const useFormManager = () => react.useContext(FormManagerContext);

exports.FormManagerProvider = FormManagerProvider;
exports.useFormManager = useFormManager;
//# sourceMappingURL=FormManagerProvider.js.map
